import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import Heading from "../ui/Heading";

const services = [
  {
    id: 1,
    title: "Residential Projects",
    description:
      "Vasudharini Homes specializes in residential construction, focusing on middle-income housing projects. Our portfolio includes a variety of home types, such as apartments, townhouses, and single-family homes, designed to meet the diverse needs of our customers.",
  },
  {
    id: 2,
    title: "Innovative Solutions",
    description:
      "We continuously explore innovative solutions in construction, including the use of eco-friendly materials, energy-efficient designs, and smart home technology. This not only reduces construction costs but also lowers the long-term operating expenses for homeowners",
  },
  {
    id: 3,
    title: "Consultation",
    description:
      "Our team of experts is available to provide consultation services to individuals or organizations looking to embark on construction projects. We can share our knowledge and experience to help others in the industry adopt cost-effective and sustainable construction practices.",
  },
];

const ServicesComponent = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });
  
  const titleVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }
    }
  };
  
  // Subtle staggered reveal for cards

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.15,
        duration: 0.7,
        ease: [0.04, 0.62, 0.23, 0.98]
      },
    }),
  };

  return (
    <section 
      ref={sectionRef} 
      className="relative py-24 bg-white"
    >
      <div className="container mx-auto px-6">
        {/* Section Heading with refined animation */}
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="text-center mb-20"
        >
          <motion.div variants={titleVariants}>
            <Heading level={2} className="text-3xl font-medium ">
              Our Services
            </Heading>
          </motion.div>
          
          {/* <motion.div
            variants={lineVariants}
            className="h-px bg-black mx-auto mt-6"
          ></motion.div> */}
        </motion.div>

        {/* Refined Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:mx-10 lg:mx-20">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              className="relative border-l border-gray-200 pl-8"
            >
              {/* Numbered marker */}
              <div className="absolute top-0 left-0 transform -translate-x-1/2 flex items-center justify-center w-6 h-6 rounded-full bg-white border border-yellow-500">
                <span className="text-xs font-medium text-yellow-500">{index + 1}</span>
              </div>

              {/* Service Title with minimal styling */}
              <h3 className="text-xl font-medium mb-4">
                {service.title}
              </h3>

              {/* Minimal line divider */}
              <div className="h-px w-10 bg-black mb-5"></div>

              {/* Description with refined typography */}
              <p className="text-gray-800 leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Optional bottom navigation row */}
        {/* <motion.div 
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          className="mt-20 pt-12 border-t border-gray-100 flex justify-between items-center"
        >
          <div className="text-sm tracking-wider uppercase">Expertise since 2005</div>
          <div className="flex items-center">
            <span className="mr-2 text-sm tracking-wider uppercase">View all services</span>
            <span className="text-sm">→</span>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default ServicesComponent;